import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Brackets: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M16 3h3v18h-3' }],
    ['path', { d: 'M8 21H5V3h3' }],
  ],
];

export default Brackets;
